import { useEffect, useCallback, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
// import Switch from "react-switch";

import io from 'socket.io-client';
import axios from "axios";
import Navbar from "../Layouts/Navbar";
import Sidebar from "../Layouts/Sidebar";
import Detail from "./SubDetail/Detail";
import LastResult from "./SubDetail/LastResult";
import ResultMaster from "./SubDetail/ResultMaster";
import ResultChart from "./SubDetail/ResultChart";
import FormatDate from "../Helpers/FormatDate";
import FormatDateTime from "../Helpers/FormatDateTime";
import NotAuthenticated from "../../hoc/NotAuthenticated";
import Note from "./SubDetail/Note";
import StatusLimit from "./SubDetail/StatusLimit";
import ResultAnalysis from "./SubDetail/ResultAnalysis";
import SuccessRate from "./SubDetail/SuccessRate";
import Custom from "./SubDetail/Custom";

const Index = () => {
    const { id } = useParams();
    const [dataMachine, setDataMachine] = useState({});
    const [socketMachine, setSocketMachine] = useState([]);
    const [tab, setTab] = useState(0);
    const [lastResult, setLastResult] = useState([]);
    const [resultChart, setResultChart] = useState([]);
    const [resultMaster, setResultMaster] = useState([]);
    const [statusLimit, setStatusLimit] = useState([]);
    const [dateNow, setDateNow] = useState('');
    const [chart, setChart] = useState([]);
    const [pieChart, setPieChart] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalUpdate, setModalUpdate] = useState(false);
    const [noteList, setNoteList] = useState([]);
    const [pictureModal, setPictureModal] = useState(null);
    const [gameCount, setGameCount] = useState(0);
    const [category, setCategory] = useState([]);
    const [chartAnalysis, setChartAnalysis] = useState({});
    const [categoryCode, setCategoryCode] = useState([]);
    const [successRate, setSuccessRate] = useState({});
    const [custom, setCustom] = useState([]);
    const [loadCustomData, setLoadCustomData] = useState(false);

    const formInput = useRef();
    const formNote = useRef();
    const formNoteFile = useRef();

    const [pageLastResult, setPageLastResult] = useState(1);
    const [totalResultList, setTotalResultList] = useState(0);
    const [totalNoteList, setTotalNoteList] = useState(0);

    const [pageNoteList, setPageNoteList] = useState(1);
    const [filerTime, setFilterTime] = useState(false);
    const [timeRange, setTimeRange] = useState(0);
    const [timeBegin, setTimeBegin] = useState('');
    const [timeEnd, setTimeEnd] = useState('');

    const [filterTimeChart, setFilterTimeChart] = useState(false);
    const [timeRangeChart, setTimeRangeChart] = useState(0);
    const [timeBeginChart, setTimeBeginChart] = useState('');
    const [timeEndChart, setTimeEndChart] = useState('');
    const [recordRow, setRecordRow] = useState(10);

    const [modalAdjust, setModalAdjust] = useState(false);
    const [roundId, setRoundId] = useState('');
    const newResultValue = useRef();
    const byWriter = useRef();

    const limitValue = useRef();
    const byValue = useRef();
    const [statusId, setStatusID] = useState('');

    const [modalAdjustV2, setModalAdjustV2] = useState(false);
    const [resultListSort, setResultListSort] = useState([]);

    const newResultCode = useRef();
    const byWriterv2 = useRef();

    const [fullScreenCam, setFullScreenCam] = useState(false);

    const [filterTimeCustom, setFilterTimeCustom] = useState(false);
    const [filterRangeTimeCustom, setFilterRangeTimeCustom] = useState(0);
    const [timeBeginCustom, setTimeBeginCustom] = useState('');
    const [timeEndCustom, setTimeEndCustom] = useState('');

    const [pageCustom, setPageCustom] = useState(1);
    const [recordRowCustom, setRecordRowCustom] = useState(10);
    const [totalDataCustom, setTotalDataCustom] = useState(0);

    useEffect(() => {
        setDateNow(FormatDate());
        setTimeBegin(FormatDateTime());
        setTimeEnd(FormatDateTime());
        setTimeBeginChart(FormatDateTime());
        setTimeEndChart(FormatDateTime());

        setTimeBeginCustom(FormatDateTime());
        setTimeEndCustom(FormatDateTime());
    }, []);

    const loadMachine = useCallback( async () => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY
        }

        let hostname = 'https://'+id.toLocaleLowerCase()+'.orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/info', body);

        const socketConfig = io(hostname);

        socketConfig.on('socketioinfo', (data) => {
            setSocketMachine(current => [...current, data]);
        });

        setDataMachine(response.data.result);
    }, [id]);

    useEffect(() => {
        loadMachine();

        return () => {
            loadMachine();
        }
    }, [loadMachine]);

    const LoadLastResult = useCallback( async (date, rpp, page, timerange, timebegin, timeend) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'date' : date,
            'page_number' : page,
            'rpp' : rpp,
            'machinecode' : id,
            'timerange' : timerange,
            'timebegin' : timebegin,
            'timeend' : timeend
        }

        let hostname = process.env.REACT_APP_HOST;
        let response = await axios.post(hostname+'/result/last', body);

        if(response.data.status){
            setTotalResultList(response.data.result.resultstotal[0].total);
            setLastResult(response.data.result.resultslast);
        }
    }, [id]);

    const loadResultChart = useCallback( async (date, timerange, timebegin, timeend) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'date' : date,
            'machinecode' : id,
            'timerange' : timerange,
            'timebegin' : timebegin,
            'timeend' : timeend
        }

        let hostname = process.env.REACT_APP_HOST;
        let response = await axios.post(hostname+'/result/chart', body);

        if(response.data.status){
            setResultChart(response.data.result.resultlist);
            setGameCount(response.data.result.gamecount);

            let resultDataChart = [
                ["Code", "Accumulation"]
            ];

            let resultDataPieChart = [
                ["Code", "Percentage"]
            ];

            response.data.result.resultlist.forEach((result) => {
                let dataChart = [
                    result.colgameresultcode, result.colgameresultaccumulation
                ];

                let dataPieChart = [
                    result.colgameresultcode, parseInt(result.percentage)
                ]

                resultDataChart.push(dataChart);
                resultDataPieChart.push(dataPieChart);
            });

            setChart(resultDataChart);
            setPieChart(resultDataPieChart);
        }
    }, [id]);

    const loadResultMaster = useCallback( async () => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'machinecode' : id
        }

        let hostname = process.env.REACT_APP_HOST;
        let response = await axios.post(hostname+'/result/list', body);

        if(response.data.status){
            setResultMaster(response.data.result);
            let result = response.data.result.sort((a, b) => {
                return a.colresultvalue.localeCompare(b.colresultvalue, undefined, { numeric: true, sensitivity: 'base' });
            });

            setResultListSort(result);
        }
    }, [id]);

    const loadNoteList = useCallback( async (page) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'rpp': 10,
            'pageno': page,
            'notemachinecode' : id
        }

        let hostname = 'https://orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/list/note', body);

        if(response.data.status){
            setNoteList(response.data.result.tblnote);
            setTotalNoteList(response.data.result.total[0].total);
        }
    }, [id]);

    const loadStatusLimit = useCallback(async() => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY
        }

        let hostname = 'https://'+id.toLocaleLowerCase()+'.orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/config/statuslimit/list', body);

        if(response.data.status){
            setStatusLimit(response.data.result);
        }
    }, [id])

    const loadResultAnalysis = useCallback( async (date, timerange, timebegin, timeend) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'date' : date,
            'machinecode' : id,
            'timerange' : timerange,
            'timebegin' : timebegin,
            'timeend' : timeend
        }

        let hostname = process.env.REACT_APP_HOST;
        let response = await axios.post(hostname+'/result/analysis', body);

        if(response.data.status)
        {
            setSuccessRate(response.data.result.success_rate);
            setCategory(response.data.result.category);
        }        
    }, [id]);

    const fetchChartData = useCallback( async(code, date, timerange, timebegin, timeend) => {
        let body = {
            'SECRET_KEY': process.env.REACT_APP_SECRETKEY,
            'date': date,
            'machinecode': id,
            'timerange': timerange,
            'timebegin': timebegin,
            'timeend': timeend
        };

        let hostname = process.env.REACT_APP_HOST;
        let response = await axios.post(`${hostname}/result/analysis/${code}`, body);

        if (response.data.status) {
            setChartAnalysis((prev) => ({
                ...prev,
                [code]: response.data.result
            }));
        }
    }, []);

    const showChartHandle = useCallback( async(code) => {
        setCategoryCode((prev) => {
            if (prev.includes(code)) {
                return prev.filter((catCode) => catCode !== code);
            } else {
                fetchChartData(code, dateNow, timeRangeChart, timeBeginChart, timeEndChart);
                return [...prev, code];
            }
        });
    }, [dateNow, timeRangeChart, timeBeginChart, timeEndChart]);

    const loadSuccessRate = useCallback( async (date) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'date' : date,
            'machinecode' : id
        }

        let hostname = process.env.REACT_APP_HOST;
        let response = await axios.post(hostname+'/result/successrate', body);

        if(response.data.status)
        {
            setSuccessRate(response.data.result)
        }        
    }, [id]);

    const loadCustom = useCallback( async (date, rpp, timerange, timebegin, timeend, page) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'page_number' : page,
            'rpp' : rpp,
            'machinecode' : id,
            'date' : date,
            'timerange' : timerange,
            'timebegin': timebegin,
            'timeend': timeend
        }

        let hostname = process.env.REACT_APP_HOST;
        let response = await axios.post(hostname+'/result/last/custom/v02', body);

        if(response.data.status){
            setTotalDataCustom(response.data.result.resultstotal[0].total);
            setCustom(response.data.result.resultscustom);
        }

        console.log(response.data.result);

        setLoadCustomData(true);
    }, []);

    useEffect(() => {
        if(tab === 0){
            loadMachine()
        }

        if(tab === 1){
            LoadLastResult(dateNow, recordRow, 1);
            loadResultMaster();
        }

        if(tab === 2){
            loadResultChart(dateNow, 0, 0);
        }

        if(tab === 3){
            loadResultMaster();
        }

        if(tab === 4){
            loadNoteList(1);
        }

        if(tab === 5){
            loadStatusLimit();
        }

        if(tab === 6){
            loadResultAnalysis(dateNow, 0, 0);
        }

        if(tab === 7){
            loadSuccessRate(dateNow);
        }

        if(tab === 8){
            loadCustom(dateNow, recordRowCustom, 0, 0, 0, 1);
        }
    }, [loadMachine, LoadLastResult, loadResultChart, loadResultMaster, loadNoteList, loadStatusLimit, loadResultAnalysis, loadSuccessRate, tab, dateNow, recordRow]);

    const handleDate = (e) => {
        setDateNow(e.target.value);
        LoadLastResult(e.target.value);
    }

    const handleDateCustom = (e) => {
        setDateNow(e.target.value);
    }

    const handleDateChart = (e) => {
        setDateNow(e.target.value);
        loadResultChart(e.target.value);
        categoryCode.forEach(code => {
            showChartHandle(code, e.target.value);
        });
        showChartHandle(categoryCode, e.target.value);
        loadSuccessRate(e.target.value);
    }

    const modalHandle = (e) => {
        setPictureModal(e);
        setModal(true);
    }

    const pinHandle = async (e) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'noteid': e.colnoteid,
            'noteispinned': e.colnoteispinned === 0 ? 1 : 0
        }

        let hostname = 'https://orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/note/pin', body);

        if(response.data.status){
            loadNoteList();
        }
    }

    const deleteHandle = async (e) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'noteid': e
        }

        let hostname = 'https://orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/note/delete', body);

        if(response.data.status){
            loadNoteList();
        }
    }

    const submitNoteHandle = async (e) => {
        e.preventDefault();

        let body = new FormData();
        body.append('SECRET_KEY', process.env.REACT_APP_SECRETKEY);
        body.append('notemachinecode', id);
        body.append('notenote', formNote.current.value);
        body.append('noteby', formInput.current.value);
        body.append('Image', formNoteFile.current.files[0]);

        let bodyNotFile = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'notemachinecode' : id,
            'notenote' : formNote.current.value,
            'noteby' : formInput.current.value
        }

        let hostname = 'https://orbiter.spacearcade.online';

        if(formNoteFile.current.files[0]){
            let responseImage = await axios.post(hostname+'/noteimage/insertnew', body);

            if(responseImage.data.status){
                formNote.current.value = '';
                formInput.current.value = '';
                formNoteFile.current.value = '';
                loadNoteList();
            }
        }else{
            let responseImage = await axios.post(hostname+'/note/insertnew', bodyNotFile);

            if(responseImage.data.status){
                formNote.current.value = '';
                formInput.current.value = '';
                loadNoteList();
            }
        }
    }

    const lastResultPageClick = (e) => {
        let pageSelected = e.selected + 1;
        setPageLastResult(pageSelected);
        LoadLastResult(dateNow, recordRow, pageSelected);
    }

    const customPageClick = (e) => {
        let pageSelected = e.selected + 1;
        setPageCustom(pageSelected);
        loadCustom(dateNow, recordRowCustom, 0, 0, 0, pageSelected);
    }

    const noteListPageClick = (e) => {
        let pageSelected = e.selected + 1;
        setPageNoteList(pageSelected);
        loadNoteList(pageSelected);
    }

    const filterTimeHandle = (e) => {
        if(e.target.checked){
            setTimeRange(1);
            setFilterTime(true);
        }else{
            setTimeRange(0);
            setFilterTime(false);
            setTimeBegin(FormatDateTime());
            setTimeEnd(FormatDateTime());
            LoadLastResult(dateNow, recordRow, 1);
        }
    }

    const filterBtnTimeHandle = () => {
        let replaceTimeBegin = timeBeginCustom.replace('T', ' ');
        let replaceTimeEnd = timeEndCustom.replace('T', ' ');

        LoadLastResult(dateNow, recordRow, 1, timeRange, replaceTimeBegin, replaceTimeEnd);
    }

    const filterBtnTimeCustomHandle = () => {
        let replaceTimeBegin = timeBeginCustom.replace('T', ' ');
        let replaceTimeEnd = timeEndCustom.replace('T', ' ');

        loadCustom(dateNow, recordRowCustom, filterRangeTimeCustom, replaceTimeBegin, replaceTimeEnd, pageCustom);
    }

    const filterTimeHandleChart = (e) => {
        if(e.target.checked){
            setTimeRangeChart(1);
            setFilterTimeChart(true);
        }else{
            setTimeRangeChart(0);
            setFilterTimeChart(false);
            setTimeBeginChart(FormatDateTime());
            setTimeEndChart(FormatDateTime());
            loadResultChart(dateNow, 0);
        }
    }

    const filterTimeCustomHandle = (e) => {
        if(e.target.checked){
            setFilterRangeTimeCustom(1);
            setFilterTimeCustom(true);
        }else{
            setFilterRangeTimeCustom(0);
            setFilterTimeCustom(false);
            setTimeBeginCustom(FormatDateTime());
            setTimeEndCustom(FormatDateTime());
            loadCustom(dateNow, 0);
        }
    }

    const filterBtnTimeHandleChart = () => {
        let replaceTimeBegin = timeBeginChart.replace('T', ' ');
        let replaceTimeEnd = timeEndChart.replace('T', ' ');

        categoryCode.forEach(code => {
            showChartHandle(code, dateNow, timeRangeChart, replaceTimeBegin, replaceTimeEnd);
        });

        loadResultChart(dateNow, timeRangeChart, replaceTimeBegin, replaceTimeEnd);
        loadResultAnalysis(dateNow, timeRangeChart, replaceTimeBegin, replaceTimeEnd);
    }

    const handleRecordRow = (e) => {
        setRecordRow(e.target.value);
        LoadLastResult(dateNow,e.target.value, 0, 0);
    }

    const handleRecordRowCustom = (e) => {
        setRecordRowCustom(e.target.value);
        loadCustom(dateNow, e.target.value, 0, 0, 0, pageCustom);
    }

    const adjustHandle = (id) => {
        setRoundId(id);
        setModalAdjust(true);
    }

    const sendHandle = async () => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'ROUND_CODE' : roundId,
            'RESULT_VALUE' : newResultValue.current.value,
            'RESULT_by' : byWriter.current.value
        }

        let hostname = 'https://orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/result/adjust', body);

        if(response.data.status){
            LoadLastResult();

            newResultValue.current.value = '';
            byWriter.current.value = '';
            setModalAdjust(false);
        }
    }

    const reloadHandle = async () => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY
        }

        let hostname = 'https://'+id.toLocaleLowerCase()+'.orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/config/statuslimit/reload', body);

        if(response.data.status){
            loadStatusLimit();
            Swal.fire('Reload Successfuly', '', 'success');
        }
    }

    const modalUpdateHandle = (value) => {
        setModalUpdate(true);  
        setStatusID(value.colmachinestatuslimitstatus);
    }

    const sendHandleLimit = async () => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'status' : statusId,
            'limit' : limitValue.current.value,
            'admin' : byValue.current.value
        }

        let hostname = 'https://'+id.toLocaleLowerCase()+'.orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/config/statuslimit/update', body);

        if(response.data.status){
            setModalUpdate(false);
            Swal.fire('Updated Limit Successfuly', 'Do a reload on the reload button to see the changes from the update limit.', 'success');
        }
    }

    const sendv2Handle = async () => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'RESULT_CODE' : newResultCode.current.value,
            'RESULT_by' : byWriterv2.current.value,
        }

        let hostname = 'https://'+id.toLocaleLowerCase()+'.orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/result/adjust/v02', body);

        if(response.data.status){
            setModalAdjustV2(false);
            Swal.fire('Adjust V2 Success', response.data.message, 'success');
        }
    }

    const requestLogHandle = async (value) => {
        let body = {
            'SECRET_KEY' : process.env.REACT_APP_SECRETKEY,
            'ROUND_CODE' : value
        }

        let hostname = 'https://'+id.toLocaleLowerCase()+'.orbiter.spacearcade.online';
        let response = await axios.post(hostname+'/log/request', body);

        if(response.data.status){
            Swal.fire('Log Request Successfuly', response.data.message, 'success');
        }
    }

    const doubleClickHandle = () => {
        setFullScreenCam(true)
    }

    document.title = 'Detail Orbiter';
    return(
        <>
            <NotAuthenticated>
                <div className="bg-[#EDF5FE] w-full min-h-full">
                    <Navbar/>
                    <Sidebar/>
                    <div className="w-full h-full pt-[64px] pl-[60px] flex flex-col">
                        <div className="py-[24px] px-[23px] h-full flex flex-col">
                            <div className="max-w-[2000px] m-auto w-full">
                                <div className="flex flex-row justify-between">
                                    <div className="flex flex-col">
                                        <h4 className="text-[#171725] font-semibold text-[24px]">{dataMachine.colmachinedescription}</h4>
                                        <div className="flex flex-row items-center">
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.707 2.79303C10.5195 2.60556 10.2651 2.50024 9.99998 2.50024C9.73482 2.50024 9.48051 2.60556 9.29298 2.79303L2.29298 9.79303C2.11082 9.98163 2.01003 10.2342 2.01231 10.4964C2.01458 10.7586 2.11975 11.0094 2.30516 11.1948C2.49057 11.3803 2.74138 11.4854 3.00358 11.4877C3.26578 11.49 3.51838 11.3892 3.70698 11.207L3.99998 10.914V17.5C3.99998 17.7652 4.10534 18.0196 4.29287 18.2071C4.48041 18.3947 4.73476 18.5 4.99998 18.5H6.99998C7.2652 18.5 7.51955 18.3947 7.70709 18.2071C7.89462 18.0196 7.99998 17.7652 7.99998 17.5V15.5C7.99998 15.2348 8.10534 14.9805 8.29287 14.7929C8.48041 14.6054 8.73476 14.5 8.99998 14.5H11C11.2652 14.5 11.5196 14.6054 11.7071 14.7929C11.8946 14.9805 12 15.2348 12 15.5V17.5C12 17.7652 12.1053 18.0196 12.2929 18.2071C12.4804 18.3947 12.7348 18.5 13 18.5H15C15.2652 18.5 15.5196 18.3947 15.7071 18.2071C15.8946 18.0196 16 17.7652 16 17.5V10.914L16.293 11.207C16.4816 11.3892 16.7342 11.49 16.9964 11.4877C17.2586 11.4854 17.5094 11.3803 17.6948 11.1948C17.8802 11.0094 17.9854 10.7586 17.9877 10.4964C17.9899 10.2342 17.8891 9.98163 17.707 9.79303L10.707 2.79303Z" fill="#374151"/>
                                            </svg>
                                            <p className="text-[#374151] text-[14px] font-medium pl-[15px]">Home</p>
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M7.29303 15.207C7.10556 15.0195 7.00024 14.7652 7.00024 14.5C7.00024 14.2348 7.10556 13.9805 7.29303 13.793L10.586 10.5L7.29303 7.20701C7.11087 7.01841 7.01008 6.76581 7.01236 6.50361C7.01463 6.24141 7.1198 5.9906 7.30521 5.80519C7.49062 5.61978 7.74143 5.51461 8.00363 5.51234C8.26583 5.51006 8.51843 5.61085 8.70703 5.79301L12.707 9.79301C12.8945 9.98054 12.9998 10.2348 12.9998 10.5C12.9998 10.7652 12.8945 11.0195 12.707 11.207L8.70703 15.207C8.5195 15.3945 8.26519 15.4998 8.00003 15.4998C7.73487 15.4998 7.48056 15.3945 7.29303 15.207Z" fill="#9CA3AF"/>
                                            </svg>
                                            <p className="text-[#374151] text-[14px] font-medium">Detail</p>
                                        </div>
                                    </div>
                                    {/* <div className="flex flex-row items-center gap-3">
                                        <div className="md:hidden">
                                            <button className="border-2 rounded-xl py-[10px] px-[12px]">
                                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.5 18H2.5M15 9.66667L10 14.6667M10 14.6667L5 9.66667M10 14.6667V3" stroke="#1A56DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </button>
                                        </div>
                                        <div className="md:hidden">
                                            <button className="border-2 rounded-xl py-[10px] px-[12px] bg-[#1A56DB]">
                                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.96388 5.04501L5.96382 5.04498C5.03946 4.48174 3.98173 5.53947 4.54497 6.46383C5.26124 7.6391 4.62589 9.17194 3.28908 9.49686L3.28896 9.49688C2.23666 9.75238 2.23811 11.2487 3.28867 11.503L3.28872 11.5031C3.59972 11.5784 3.88854 11.7261 4.13164 11.9342C4.37475 12.1423 4.56527 12.4049 4.6877 12.7005C4.81012 12.9962 4.86099 13.3166 4.83616 13.6356C4.81132 13.9547 4.71149 14.2633 4.54479 14.5365C3.98202 15.4607 5.03934 16.518 5.96353 15.9552L5.96388 5.04501ZM5.96388 5.04501C6.23708 5.21143 6.54572 5.311 6.86467 5.33561C7.18362 5.36022 7.50387 5.30917 7.79937 5.18663C8.09487 5.06409 8.35726 4.87351 8.56519 4.63041C8.77304 4.38739 8.9206 4.09876 8.99588 3.78797C9.24801 2.7543 10.6999 2.73762 10.9907 3.73792L11.0031 3.78873C11.0784 4.09973 11.2261 4.38854 11.4342 4.63165C11.6423 4.87475 11.9049 5.06528 12.2005 5.1877C12.4962 5.31013 12.8166 5.36099 13.1356 5.33616C13.4546 5.31133 13.7633 5.2115 14.0365 5.0448C14.9607 4.48203 16.018 5.53934 15.4552 6.46353C15.2885 6.73669 15.1887 7.04535 15.1638 7.36438C15.139 7.68342 15.1899 8.00381 15.3123 8.29947C15.4347 8.59513 15.6252 8.85769 15.8683 9.06578C16.1115 9.27387 16.4003 9.4216 16.7113 9.49694L16.7113 9.49696C17.7619 9.75135 17.7633 11.2476 16.711 11.5031L16.7108 11.5032C16.4 11.5788 16.1115 11.7266 15.8686 11.9347C15.6257 12.1428 15.4353 12.4053 15.3129 12.7008C15.1906 12.9963 15.1397 13.3165 15.1643 13.6354C15.189 13.9543 15.2886 14.2629 15.455 14.5361L15.455 14.5362C16.0183 15.4605 14.9605 16.5183 14.0362 15.955L14.0361 15.955C13.7629 15.7886 13.4543 15.689 13.1354 15.6643C12.8165 15.6397 12.4963 15.6906 12.2008 15.8129C11.9053 15.9353 11.6428 16.1257 11.4347 16.3686C11.2266 16.6115 11.0787 16.9001 11.0032 17.2108L11.003 17.2113M5.96388 5.04501L11.003 17.2113M11.003 17.2113C10.7486 18.2619 9.25237 18.2633 8.99688 17.211C8.92152 16.9001 8.77381 16.6114 8.56577 16.3684C8.35768 16.1252 8.09512 15.9347 7.79946 15.8123C7.50381 15.6899 7.18342 15.639 6.86438 15.6638C6.5454 15.6887 6.23679 15.7885 5.96368 15.9551L11.003 17.2113ZM10 14C10.9283 14 11.8185 13.6313 12.4749 12.9749C13.1312 12.3185 13.5 11.4283 13.5 10.5C13.5 9.57174 13.1312 8.6815 12.4749 8.02513C11.8185 7.36875 10.9283 7 10 7C9.07174 7 8.1815 7.36875 7.52512 8.02513C6.86874 8.6815 6.49999 9.57174 6.49999 10.5C6.49999 11.4283 6.86874 12.3185 7.52512 12.9749C8.1815 13.6313 9.07174 14 10 14Z" fill="white" stroke="white"/>
                                                </svg>
                                            </button>
                                        </div>
                                        
                                        <div className="hidden md:block">
                                            <button className="flex flex-row items-center justify-center border-2 rounded-lg py-[8px] w-[150px] gap-3 text-[#1A56DB] font-medium">
                                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.5 14.5H2.5M12.5 7.83333L8.5 11.8333M8.5 11.8333L4.5 7.83333M8.5 11.8333V2.5" stroke="#1A56DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Download
                                            </button>
                                        </div>

                                        <div className="hidden md:block">
                                            <button className="flex flex-row items-center justify-center border-2 rounded-lg py-[8px] w-[150px] gap-3 bg-[#1A56DB] text-white font-medium">
                                                Config
                                            </button>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="mt-[24px] w-full h-full">
                                    <div className="bg-white rounded-xl p-[16px]">
                                        <h3 className="text-black font-medium text-[20px]">Camera</h3>

                                        <div className="mt-[16px]">
                                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                                                <div className="w-full relative">
                                                    {dataMachine.colmachineurl01 === '' ?
                                                        <img src={process.env.PUBLIC_URL+'/img/blank.png'} alt="blank.png" className="w-full h-[320px] lg:h-[250px] 2xl:h-[320px] rounded-xl"/>
                                                    : 
                                                        <iframe className="w-full h-[320px] lg:h-[250px] 2xl:h-[320px] rounded-xl" src={dataMachine.colmachineurl01} title="description"></iframe>
                                                    }
                                                    {/* <div className="mt-[8px] flex flex-row justify-between items-center">
                                                        <label className="text-black font-normal">Camera 1</label>
                                                        <Switch height={20} width={40}/>
                                                    </div> */}
                                                    <div className="bg-transparent w-full h-full inset-0 absolute cursor-pointer" onDoubleClick={doubleClickHandle}></div>
                                                </div>
                                                <div className="w-full">
                                                    {dataMachine.colmachineurl02 === '' ?
                                                        <img src={process.env.PUBLIC_URL+'/img/blank.png'} alt="blank.png" className="w-full h-[320px] lg:h-[250px] 2xl:h-[320px] rounded-xl"/>
                                                    : 
                                                        <iframe className="w-full h-[320px] lg:h-[250px] 2xl:h-[320px] rounded-xl" src={dataMachine.colmachineurl02} title="description"></iframe>
                                                    }
                                                    {/* <div className="mt-[8px] flex flex-row justify-between items-center">
                                                        <label className="text-black font-normal">Camera 1</label>
                                                        <Switch height={20} width={40}/>
                                                    </div> */}
                                                </div>
                                                <div className="w-full">
                                                    {dataMachine.colmachineurl03 === '' ?
                                                        <img src={process.env.PUBLIC_URL+'/img/blank.png'} alt="blank.png" className="w-full h-[320px] lg:h-[250px] 2xl:h-[320px] rounded-xl"/>
                                                    : 
                                                        <iframe className="w-full h-[320px] lg:h-[250px] 2xl:h-[320px] rounded-xl" src={dataMachine.colmachineurl03} title="description"></iframe>
                                                    }
                                                    {/* <div className="mt-[8px] flex flex-row justify-between items-center">
                                                        <label className="text-black font-normal">Camera 1</label>
                                                        <Switch height={20} width={40}/>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="my-5 w-full overflow-auto">
                                        <div className="flex flex-row gap-9">
                                            <button className={tab === 0 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(0)}>Details</button>
                                            <button className={tab === 1 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(1)}>Last Result</button>
                                            <button className={tab === 8 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(8)}>Custom</button> 
                                            <button className={tab === 2 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(2)}>Result Chart</button>
                                            <button className={tab === 6 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(6)}>Result Analysis</button>
                                            <button className={tab === 7 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(7)}>Success Rate</button>
                                            <button className={tab === 3 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(3)}>Result Master</button>
                                            <button className={tab === 4 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(4)}>Note</button>
                                            <button className={tab === 5 ?`border-b-2 border-[#4743FE] text-[#4743FE] py-[8px] text-[20px] font-medium whitespace-nowrap` : 'py-[8px] text-[#6B7280] text-[20px] font-medium whitespace-nowrap'} onClick={() => setTab(5)}>Status Limit</button>
                                        </div>
                                    </div>
                                    
                                    {tab === 0 ? <Detail datamachine={dataMachine} socketmachine={socketMachine}/> : '' }
                                    {tab === 1 ? <LastResult datalastresult={lastResult} handledate={handleDate} datenow={dateNow} lastresultpageclick={lastResultPageClick} 
                                    pagenumber={pageLastResult} totaldata={totalResultList} filtertime={filerTime} filtertimehandle={filterTimeHandle} timebegin={timeBegin} timeend={timeEnd}
                                    handletimebegin={(e) => setTimeBegin(e.target.value)} handletimeend={(e) => setTimeEnd(e.target.value)} filterbtntimehandle={filterBtnTimeHandle}
                                    handlerecordrow={(e) => handleRecordRow(e)} countrecord={recordRow} adjusthandle={adjustHandle} modal={modalAdjust} cancel={() => 
                                    setModalAdjust(false)} newresultvalue={newResultValue} bywriter={byWriter} send={sendHandle} requestloghandle={requestLogHandle}
                                    modaladjustv2={modalAdjustV2} modaladjusthandle={() => setModalAdjustV2(true)} cancelmodaladjust={() => setModalAdjustV2(false)} dataresultlist={resultListSort}
                                    newresultcode={newResultCode} bywriterv2={byWriterv2} sendv2={sendv2Handle}/> : '' }
                                    
                                    {tab === 2 ? <ResultChart dataresultchart={resultChart} chart={chart} 
                                    piechart={pieChart} gamecount={gameCount} handledatechart={handleDateChart} datenow={dateNow}
                                    filtertimechart={filterTimeChart} filtertimehandlechart={filterTimeHandleChart} timebeginchart={timeBeginChart} timeendchart={timeEndChart}
                                    handletimebeginchart={(e) => setTimeBeginChart(e.target.value)} handletimeendchart={(e) => setTimeEndChart(e.target.value)} filterbtntimehandlechart={filterBtnTimeHandleChart}
                                    /> : '' }
                                    
                                    {tab === 3 ? <ResultMaster dataresultmaster={resultMaster}/> : '' }

                                    {tab === 4 ? <Note datanote={noteList} modal={modal} modalhandle={modalHandle}
                                    picturemodal={pictureModal} pinhandle={pinHandle} deletehandle={deleteHandle} 
                                    forminput={formInput} formnote={formNote} formnotefile={formNoteFile} 
                                    submitnotehandle={submitNoteHandle} notelistpageclick={noteListPageClick} pagenumber={pageNoteList}
                                    totaldata={totalNoteList}
                                    cancel={() => setModal(false)}/> : '' }

                                    {tab === 5 ? <StatusLimit datastatuslimit={statusLimit} reloadhandle={reloadHandle} 
                                    modal={modalUpdate} modalupdatehandle={modalUpdateHandle} cancel={() => setModalUpdate(false)} limitvalue={limitValue} byvalue={byValue}
                                    sendhandle={sendHandleLimit}/> : ''}

                                    {tab === 6 ? <ResultAnalysis datasuccessrate={successRate} datacategory={category} handledatechart={handleDateChart} datenow={dateNow}
                                    filtertimechart={filterTimeChart} filtertimehandlechart={filterTimeHandleChart} timebeginchart={timeBeginChart} timeendchart={timeEndChart}
                                    handletimebeginchart={(e) => setTimeBeginChart(e.target.value)} handletimeendchart={(e) => setTimeEndChart(e.target.value)} filterbtntimehandlechart={filterBtnTimeHandleChart}
                                    showcharthandle={showChartHandle} datachartanalysis={chartAnalysis} categorycode={categoryCode} id={id}/> : ''}

                                    {tab === 7 ? <SuccessRate successrate={successRate} datenow={dateNow} handledatechart={handleDateChart}/> : ''}

                                    {tab === 8 ? <Custom handlerecordrow={(e) => handleRecordRowCustom(e)} custompageclick={customPageClick} totaldata={totalDataCustom}
                                    countrecord={recordRowCustom} pagenumber={pageCustom} datacustom={custom} datenow={dateNow} 
                                    timebegin={timeBeginCustom} timeend={timeEndCustom} 
                                    handletimebegin={(e) => setTimeBeginCustom(e.target.value)} 
                                    handletimeend={(e) => setTimeEndCustom(e.target.value)} 
                                    filterbtntimecustomehandle={filterBtnTimeCustomHandle} 
                                    handledatecustom={handleDateCustom} 
                                    loadcustomdata={loadCustomData} filtertimecustom={filterTimeCustom} 
                                    filtertimecustomhandle={(e) => filterTimeCustomHandle(e)}></Custom> : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {fullScreenCam ?
                <div className="bg-black fixed w-full h-full z-10 top-0">
                    <div className="w-full py-3 px-4 fixed top-0">
                        <button onClick={() => setFullScreenCam(false)}>
                            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.75 26.25L26.25 8.75M26.25 26.25L8.75 8.75" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    <div className="w-full h-full">
                        {dataMachine.colmachineurl01 === '' ?
                            <img src={process.env.PUBLIC_URL+'/img/blank.png'} alt="blank.png" className="w-full h-full"/>
                        : 
                            <iframe className="w-full h-full" src={dataMachine.colmachineurl01} title="description"></iframe>
                        }
                    </div>
                </div> : null }
            </NotAuthenticated>
        </>
    );
}

export default Index;